import React, { FC, useEffect } from "react";

type TExpandableOverlayCarouselArrowProps = {
  direction: "previous" | "next";
  onClick: () => void;
};

const OverlayCarouselArrow: FC<TExpandableOverlayCarouselArrowProps> = ({
  direction,
  onClick,
}) => {
  const icon = "dcx-chevron-" + (direction === "previous" ? "left" : "right");

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <button
      className={
        "series-overview-expandable-overlay__arrow-control series-overview-expandable-overlay__arrow-control--" +
        direction
      }
      aria-label={direction + "slide / item"}
      onClick={onClick}
    >
      <pfe-icon icon={icon} size="24" color="complement" />
    </button>
  );
};

export default OverlayCarouselArrow;
